// import logo from "./logo.svg";
import React, { lazy, Suspense } from "react";
import "./App.css";
import "./i18n";
import "react-notifications/lib/notifications.css";
import ErrHandler from "../src/ErrHandler/ErrHandler";
import CountryThemeSync from "./components/CountryThemeSync/CountryThemeSync";
// import { HashRouter, Route, Switch } from "react-router-dom";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
// import DatePicker from './datePicker'
// import GenericFooter from "../src/components/Footer/GenericFooter";
import Fallback from "../src/components/Fallback/Fallback";
const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const MainDashBoard = lazy(() => import("./pages/HomePage/MainDashBoard"));
const VitalSigns = lazy(() => import("./pages/VitalSigns/AddVitalSigns"));
const MedicalRecordDB = lazy(() =>
  import("./pages/MedicalRecords/MedicalRecordDB")
);
const ApptHistoryDB = lazy(() =>
  import("./pages/History/AppiontmentHistory/ApptHistoryDB")
);
const LabOrderHistoryDB = lazy(() =>
  import("./pages/History/LabOrderHistory/LabOrderHistoryDB")
);
const BuyMedicineHistoryDB = lazy(() =>
  import("./pages/History/BuyMedicineHistory/BuyMedicineHistoryDB")
);
const MyHistoryDB = lazy(() => import("./pages/History/MyHistory/MyHistoryDB"));

const AppointmentDB = lazy(() =>
  import("./pages/AppointmentPage/AppointmentDB")
);
const BookLabApptDB = lazy(() => import("./pages/BookLabPages/BookLabApptDB"));
const BuyMedicineDB = lazy(() =>
  import("./pages/BuyMedicinePages/BuyMedicineDB")
);
const UserProfileDB = lazy(() =>
  import("./pages/UserProfilePages/UserProfileDB")
);
const RegistrationForm = lazy(() => import("./pages/Login/RegistrationForm"));

const CareTeamMembersProfile = lazy(() =>
  import("./pages/CareTeam/CareTeamMembersProfile")
);
const LoginPage = lazy(() => import("./pages/Login/LoginPage"));
const SelectProfile = lazy(() => import("./pages/Login/DefaultLocation"));

const LabReports = lazy(() => import("./pages/MedicalRecords/LabReports"));
const LinksPage = lazy(() => import("./pages/HomePage/LinksPage"));
const DocchoicePrivacyPolicy = lazy(() =>
  import("./pages/DocchoicePrivacyPolicy")
);
const DocchoiceTermsandconditions = lazy(() =>
  import("./pages/DocchoiceTermsandconditions")
);
const HealthCardReg = lazy(() =>
  import("./pages/UserProfilePages/HealthCardReg")
);
const NotFoundPage = lazy(() => import("./pages/Errors/NotFoundPage"));
const ServerErrorPage = lazy(() => import("./pages/Errors/ServerErrorPage"));
const NetworkErrorPage = lazy(() => import("./pages/Errors/NetworkErrorPage"));
const SessionErrorPage = lazy(() => import("./pages/Errors/SessionErrorPage"));

const App = () => {
  return (
    <>
      <div onContextMenu={(e) => e.preventDefault()}>
        {/* <DatePicker></DatePicker> */}
        <Router basename="/">
          <CountryThemeSync>
          <ErrHandler>
            <Suspense fallback={<Fallback />}>
              <Switch>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/MainDashBoard" component={MainDashBoard} />
                <Route
                  exact
                  path="/MedicalRecordDB"
                  component={MedicalRecordDB}
                />
                <Route exact path="/VitalSigns" component={VitalSigns} />
                <Route exact path="/ApptHistoryDB" component={ApptHistoryDB} />
                <Route
                  exact
                  path="/RegistrationForm"
                  component={RegistrationForm}
                />
                <Route
                  exact
                  path="/LabOrderHistoryDB"
                  component={LabOrderHistoryDB}
                />
                <Route
                  exact
                  path="/BuyMedicineHistoryDB"
                  component={BuyMedicineHistoryDB}
                />
                <Route exact path="/MyHistory" component={MyHistoryDB} />
                <Route exact path="/AppointmentDB" component={AppointmentDB} />
                <Route exact path="/BookLabApptDB" component={BookLabApptDB} />
                <Route exact path="/BuyMedicineDB" component={BuyMedicineDB} />
                <Route
                  exact
                  path="/CareTeamMembersProfile"
                  component={CareTeamMembersProfile}
                />

                <Route exact path="/UserProfileDB" component={UserProfileDB} />
                <Route exact path="/LoginPage" component={LoginPage} />
                <Route exact path="/SelectProfile" component={SelectProfile} />
                <Route exact path="/LabReports" component={LabReports} />
                <Route exact path="/LinksPage" component={LinksPage} />
                <Route
                  exact
                  path="/DocchoicePrivacyPolicy"
                  component={DocchoicePrivacyPolicy}
                />
                <Route
                  exact
                  path="/DocchoiceTermsandconditions"
                  component={DocchoiceTermsandconditions}
                />
                <Route exact path="/HealthCardReg" component={HealthCardReg} />
                <Route exact path="/404" component={NotFoundPage} />
                <Route exact path="/error/server" component={ServerErrorPage} />
                <Route exact path="/error/network" component={NetworkErrorPage} />
                <Route exact path="/error/session" component={SessionErrorPage} />
                <Route component={NotFoundPage} />
              </Switch>
            </Suspense>
          </ErrHandler>
          </CountryThemeSync>
        </Router>
      </div>

      {/* <div><GenericFooter /></div> */}
    </>
  );
};

export default App;
